import './assets/styles/main.scss';
import App from './app/app';

const page = new App();
page.run();
